
import React from "react";
import PageLayout from "@/components/PageLayout";
import { ExternalLink } from "lucide-react";
import { Button } from "@/components/ui/button";

const InTheMedia = () => {
  const mediaFeatures = [
    {
      publication: "Tech Insider",
      title: "RedFlags Brings Transparency to Tech Workplace Culture",
      date: "May 12, 2023",
      excerpt: "The new platform is quickly becoming an essential tool for job seekers in the competitive tech industry...",
      link: "#",
    },
    {
      publication: "Business Daily",
      title: "How Anonymous Reviews are Changing Hiring Practices",
      date: "March 28, 2023",
      excerpt: "Companies are taking note as platforms like RedFlags influence candidate decisions...",
      link: "#",
    },
    {
      publication: "Startup Chronicle",
      title: "RedFlags Founder on Building Trust in the Job Market",
      date: "February 15, 2023",
      excerpt: "In an exclusive interview, we learn about the mission to create more ethical workplaces...",
      link: "#",
    },
    {
      publication: "HR Innovation Magazine",
      title: "The Rise of Workplace Transparency Platforms",
      date: "January 8, 2023",
      excerpt: "RedFlags and similar platforms are pushing employers to address workplace issues proactively...",
      link: "#",
    },
  ];

  const quotes = [
    {
      quote: "RedFlags is revolutionizing how candidates evaluate potential employers by giving voice to employee experiences.",
      source: "Future of Work Podcast",
    },
    {
      quote: "Finally, a platform that prioritizes honest feedback while protecting users' identities. RedFlags fills a critical gap in the job search process.",
      source: "Career Development Monthly",
    },
  ];

  return (
    <PageLayout 
      title="In The Media" 
      description="See what people are saying about RedFlags and how we're changing workplace transparency."
    >
      <div className="space-y-16">
        {/* Featured Articles Section */}
        <section>
          <h2 className="text-2xl font-semibold text-redflags-dark text-center mb-8">
            Featured Articles
          </h2>
          <div className="grid gap-8">
            {mediaFeatures.map((feature, index) => (
              <div 
                key={index} 
                className="bg-slate-50 p-6 rounded-xl border border-slate-100"
              >
                <div className="flex flex-col gap-2">
                  <span className="text-sm text-redflags-red font-medium">{feature.publication}</span>
                  <h3 className="font-semibold text-xl text-redflags-dark">{feature.title}</h3>
                  <p className="text-sm text-redflags-gray">{feature.date}</p>
                  
                  <p className="text-redflags-gray my-4">{feature.excerpt}</p>
                  
                  <Button variant="outline" size="sm" className="w-fit flex items-center gap-2">
                    Read Full Article
                    <ExternalLink className="h-3 w-3" />
                  </Button>
                </div>
              </div>
            ))}
          </div>
        </section>
        
        {/* Press Quotes Section */}
        <section>
          <h2 className="text-2xl font-semibold text-redflags-dark text-center mb-8">
            What They're Saying
          </h2>
          <div className="grid md:grid-cols-2 gap-6">
            {quotes.map((item, index) => (
              <div 
                key={index} 
                className="bg-slate-50 p-6 rounded-xl border border-slate-100"
              >
                <blockquote className="text-redflags-gray italic">"
                  {item.quote}
                  "
                </blockquote>
                <p className="text-right font-medium text-redflags-dark mt-4">— {item.source}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Press Contact Section */}
        <section className="bg-redflags-red/5 p-8 rounded-xl border border-redflags-red/10">
          <h2 className="text-xl font-semibold text-redflags-dark mb-4">
            Press Inquiries
          </h2>
          <p className="text-redflags-gray mb-6">
            For media inquiries, interview requests, or additional information about RedFlags, please reach out to our press team.
          </p>
          <Button className="bg-redflags-red hover:bg-redflags-red/90">
            Contact Press Team
          </Button>
        </section>
      </div>
    </PageLayout>
  );
};

export default InTheMedia;
